import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const userMenuRegistry = {
    core_user: {
        label: "User",
        link: PAGE_URL.USER_PAGE,
        key: PAGE_URL.USER_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default userMenuRegistry;
